module.exports = __webpack_public_path__ + "img/sLD_Token_voucher_40k_eth.c2d3e3d2.jpg";